import {
  MenuItem,
  TextField,
  TextFieldProps,
} from "@mui/material";

import { Maybe, PatientSexEnum } from "~/graphql/__generated__/graphql";

type PatientSexFormProps = {
  sex: Maybe<PatientSexEnum>;
  setSex: (sex: Maybe<PatientSexEnum>) => void;
} & Omit<Omit<TextFieldProps, "value">, "onChange">;

const PatientSexForm = ({
  sex,
  setSex,
  ...additionalProps
}: PatientSexFormProps) => {
  return (<TextField
    select
    value={sex ? sex : ""}
    onChange={(e) => setSex(e.target.value ? e.target.value as PatientSexEnum : null)}
    {...additionalProps}
  >
    <MenuItem value="">&nbsp;</MenuItem>
    <MenuItem value="female">Female</MenuItem>
    <MenuItem value="male">Male</MenuItem>
    <MenuItem value="prefer_not_to_say">Prefer not to say</MenuItem>
    <MenuItem value="other">Other</MenuItem>
  </TextField>);
};

export default PatientSexForm;
